export default "__VITE_ASSET__C2D5XW7a__"